import { MatchDetailsStylesSchema } from './NewMatchDetailsPage.styles';

export const matchDetailsStyles: MatchDetailsStylesSchema = {
  headerFlex: {
    justify: 'space-between',
  },
  headerHeading: {
    alignItems: 'center',
    display: 'flex',
    fontSize: ['lg', null, '2xl'],
    color: 'white',
    fontWeight: 'normal',
    fontFamily: 'Spectral',
    textShadow: '0px 4px 3px rgba(0, 0, 0, 0.15)',
    lineHeight: 'unset',
  },
  headerIconButton: {
    color: 'white',
    p: '1',
    size: 'xs',
    variant: 'link',
    _hover: {
      opacity: '.8',
    },
  },
  headerVsBox: {
    color: 'beta.500',
  },
  bodyStack: {
    color: 'white',
    mt: ['-1', null, '0', '-2'],
    p: ['2', null, null, '4'],
    minH: '90vh',
  },
  bodyInnerWrapper: {
    alignItems: 'center',
    display: [null, null, null, 'flex'],
    justifyContent: 'space-between',
  },
  sgmLogo: {
    color: 'beta.500',
    h: '1.25em',
    ml: '1',
    w: 'auto',
  },
  scrollButtonGroup: {
    variant: 'filter',
    bg: 'transparent',
    boxShadow: 'none',
  },
  toMarketButton: {
    borderColor: 'alpha.200',
    _last: { mr: 2 },
  },
  loadingSkeletonText: {
    my: '4',
    spacing: '4',
    skeletonHeight: '2',
  },
  accordion: {
    display: 'flex',
    flexDir: ['column', null, null, 'row'],
    mx: '-1',
  },
  accordionStack: {
    px: '1',
    w: { lg: '50%' },
    _notFirst: {
      mt: ['2', null, null, '0'],
    },
  },
  accordionItem: {
    bgGradient: 'linear(to-b, alpha.500, alpha.600)',
    border: '0',
    borderRadius: 'base',
    boxShadow:
      '0px 3px 5px 0px rgba(0, 0, 0, 0.20), 0px 1px 0px 0px rgba(255, 255, 255, 0.15) inset',
    overflow: 'hidden',
  },
  accordionButton: {
    fontSize: 'xs',
    fontWeight: 'bold',
    p: '2',
    pos: 'relative',
    textAlign: 'left',
    _after: {
      borderBottomWidth: '1px',
      borderColor: 'blackAlpha.400',
      bottom: '0',
      boxShadow: '0 1px rgba(255, 255, 255, .07)',
      content: '""',
      left: '0',
      opacity: '0',
      pos: 'absolute',
      right: '0',
      transition: 'inherit',
      zIndex: '1',
    },
    _expanded: {
      _after: { opacity: '1' },
    },
  },

  marketLayoutIconFlex: {
    align: 'center',
    flex: '1',
    gap: '1',
    color: 'white',
    fontSize: 'sm',
    fontWeight: 'bold',
  },
  marketLayoutTooltip: {
    fontSize: 'xs',
  },
  marketLayoutIcon: {
    color: 'delta.700',
    fontSize: 'lg',
  },
  marketLoadingCenter: {
    boxSize: '6',
  },
  centerLoadingSpinner: {
    color: 'white',
    size: 2,
  },
  marketLayoutLoadedIcon: {
    color: 'white',
    fontSize: '2xl',
  },
  marketLayoutAccordionPanel: {
    bg: 'white',
    p: '0',
  },
  cancelButton: {
    variant: 'solid',
    px: '3',
  },
  clearButton: {
    fontFamily: 'roboto',
    fontSize: 'xs',
    ml: '3',
    px: '3',
  },
  countdown: {
    sx: {
      textTransform: 'uppercase',
      '&&&.state-prior': {
        py: 0,
        px: 1,
        lineHeight: 'initial',
      },
    },
  },
  sgmLogoV2: {
    color: 'white',
    w: '9',
    h: 'auto',
  },
  wrapperScrollSgm: {
    w: '100%',
    maxW: '100%',
    gap: [null, null, 1],
  },
  scrollButtonGroupV2: {
    variant: 'unstyled',
    flex: 1,
    position: 'relative',
    minH: '34px',
  },
  accordionItemActive: {
    boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.2)',
  },
  toMarketButtonV2: {
    color: 'white',
    fontSize: 'xs',
    textTransform: 'uppercase',
    minW: 'fit-content',
    fontWeight: 'bold',
    cursor: 'pointer',

    sx: {
      '&&': {
        px: 2,
        ml: 0,
      },
      '&[data-active]': {
        color: 'beta.500',
      },

      '.chakra-button__icon': {
        margin: 0,
      },
    },

    _last: { mr: 2 },
  },
  sgmBtn: {
    sx: {
      boxShadow:
        '0px 0px 0px 2px #FFA902 inset, 0px 0px 0px 4px #74500B inset, 0px 0px 0px 5px rgba(255, 255, 255, 0.40) inset',
      svg: {
        color: 'blackAlpha.700',
        fill: 'blackAlpha.700',
      },
    },
  },
  sgmBtnActive: {
    boxShadow: '0px 2px 4px 0px #00000040 inset, 0px 1px 0px 0px #FFFFFF1A',

    sx: {
      svg: {
        color: 'beta.500',
        fill: 'beta.500',
      },

      '&&': {
        bg: 'blackAlpha.400',
        boxShadow:
          '0px 2px 4px 0px rgba(0, 0, 0, 0.40) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.15)',
      },
    },

    _after: { display: 'none' },
  },
};
